import { useMutation } from '@tanstack/react-query';
import { Service } from '@/infra/services/user';

interface ChangePasswordUserParams {
	password: string;
	current_password: string;
}

export function useChangePasswordUser() {
	return useMutation({
		mutationFn: (params: ChangePasswordUserParams) => Service.changePassword(params)
	});
}
